export default {

  SETUSERALLIST(state, data) {
    state.userManagement.totalList = data
  },

  SETPAGEMANAGEMENTUSERALL(state, data) {
    state.userManagement.pageManagement = data
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/UserManagement/mutations.js